import React from 'react'
import styles from './FeaturedStories.module.css'
import { useNavigate, useSearchParams } from "react-router-dom";
import categoryContent from "../../../json/categoryContent.json";

const FEATURED_IMAGES = [
  "Images/insights_img.webp",
  "/Images/latest_drop3.webp",
];

const FeaturedStories = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categorySlug = searchParams.get("category");
  const sectionSlug = searchParams.get("section");

  if (categorySlug !== "media-pick-ups") return null;

  const allItems = categoryContent[categorySlug]?.items || [];
  const items = allItems.slice(6, 8);

  if (items.length < 2) return null;

  const [largeItem, smallItem] = items;

  const handleClick = (item) => {
    if (item.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    } else {
      navigate(`/blog-detail?section=${sectionSlug}&category=${categorySlug}`);
    }
  };

  return (
    <>
      <section className={styles.wrapper}>
        <div className={styles.container}>
          <h2 className={styles.heading}>Featured stories</h2>

          <div className={styles.grid}>
            <article
              className={`${styles.card} ${styles.largeCard}`}
              onClick={() => handleClick(largeItem)}
            >
              <div className={styles.imageWrapper}>
                <img
                  src={FEATURED_IMAGES[0]}
                  alt={largeItem.title}
                  className={styles.image}
                loading="lazy" decoding="async" />
              </div>

              <div className={styles.content}>
                <h3 className={styles.cardTitle}>{largeItem.title}</h3>
                {largeItem.date && (
                  <p className={styles.cardDate}>{largeItem.date}</p>
                )}
                <h3 className={styles.title}>{largeItem.description}</h3>

                <button className={styles.readMore}>
                  Read more
                  <img src="/svg/arrow_new.svg" alt="arrow_new" loading="lazy" decoding="async" />
                </button>
              </div>
            </article>

            <article className={styles.card} onClick={() => handleClick(smallItem)}>
              <div className={styles.imageWrapper}>
                <img
                  src={FEATURED_IMAGES[1]}
                  alt={smallItem.title}
                  className={styles.image}
                loading="lazy" decoding="async" />
              </div>

              <div className={styles.content}>
                <h3 className={styles.cardTitle}>{smallItem.title}</h3>
                {smallItem.date && (
                  <p className={styles.cardDate}>{smallItem.date}</p>
                )}
                <h3 className={styles.title}>{smallItem.description}</h3>

                <button className={styles.readMore}>
                  Read more
                  <img src="/svg/arrow_new.svg" alt="arrow_new" loading="lazy" decoding="async" />
                </button>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}

export default FeaturedStories
